//QUIZZES
export const COURSES_IS_LOADING = 'COURSES_IS_LOADING';
export const COURSES_LOAD_SUCCESS = 'COURSES_LOAD_SUCCESS';
export const COURSES_LOAD_ERROR = 'COURSES_LOAD_ERROR';

//SELECTED COURSE
export const SELECTED_COURSE_IS_LOADING = 'SELECTED_COURSE_IS_LOADING';
export const SELECTED_COURSE_LOAD_SUCCESS = 'SELECTED_COURSE_LOAD_SUCCESS';
export const SELECTED_COURSE_LOAD_ERROR = 'SELECTED_COURSE_LOAD_ERROR';
export const RESET_SELECTED_COURSE = 'RESET_SELECTED_COURSE';

//QUIZZES
export const QUIZZES_IS_LOADING = 'QUIZZES_IS_LOADING';
export const QUIZZES_LOAD_SUCCESS = 'QUIZZES_LOAD_SUCCESS';
export const QUIZZES_LOAD_ERROR = 'QUIZZES_LOAD_ERROR';

//SELECTED QUIZ
export const SELECTED_QUIZ_IS_LOADING = 'SELECTED_QUIZ_IS_LOADING';
export const SELECTED_QUIZ_LOAD_SUCCESS = 'SELECTED_QUIZ_LOAD_SUCCESS';
export const SELECTED_QUIZ_LOAD_ERROR = 'SELECTED_QUIZ_LOAD_ERROR';
export const RESET_SELECTED_QUIZ = 'RESET_SELECTED_QUIZ';

//QUIZ QUESTIONS
export const QUESTIONS_ARE_LOADING = 'QUESTIONS_ARE_LOADING';
export const QUESTIONS_LOAD_SUCCESS = 'QUESTIONS_LOAD_SUCCESS';
export const QUESTIONS_LOAD_ERROR = 'QUESTIONS_LOAD_ERROR';
export const RESET_QUESTIONS = 'RESET_QUESTIONS';

//QUIZ ACTIVE 
export const QUIZ_IN_PROGRESS = 'QUIZ_IN_PROGRESS';
export const QUIZ_COMPLETED = 'QUIZ_COMPLETED';
export const RESET_QUIZ_STATE = 'RESET_QUIZ_STATE';
export const PLAY_AGAIN_QUIZ = "PLAY_AGAIN_QUIZ";

//HEADER TEXT
export const SET_HEADER_TEXT = 'SET_HEADER_TEXT';
export const SELECTED_MENU_ITEM = 'SELECTED_MENU_ITEM';
export const SET_HEADER_ADVANCED_SEARCH_PARAMS = "SET_HEADER_ADVANCED_SEARCH_PARAMS";
export const RESET_HEADER = "RESET_HEADER";

//ANSWERING QUESTIONS
export const IS_ANSWERING_QUESTION = 'IS_ANSWERING_QUESTION';
export const ANSWER_QUESTION_SUCCESS = 'ANSWER_QUESTION_SUCCESS';
export const ANSWER_QUESTION_ERROR = 'ANSWER_QUESTION_ERROR';
export const RESET_ANSWER_STATE = 'RESET_ANSWER_STATE';

// ANNOUNCEMENTS MODULE
export const ANNOUNCEMENTS_IS_LOADING = "ANNOUNCEMENTS_IS_LOADING";
export const ANNOUNCEMENTS_LOAD_SUCCESS = "ANNOUNCEMENTS_LOAD_SUCCESS";
export const ANNOUNCEMENTS_LOAD_ERROR = "ANNOUNCEMENTS_LOAD_ERROR";

// STATISTICS - DASHBOARD MODULE
export const STATISTICS_IS_LOADING = "STATISTICS_IS_LOADING";
export const STATISTICS_LOAD_SUCCESS = "STATISTICS_LOAD_SUCCESS";
export const STATISTICS_LOAD_ERROR = "STATISTICS_LOAD_ERROR";

// LEADERSHIP BOARD - DASHBOARD MODULE
export const LEADERSHIP_BOARD_IS_LOADING = "LEADERSHIP_BOARD_IS_LOADING";
export const LEADERSHIP_BOARD_LOAD_SUCCESS = "LEADERSHIP_BOARD_LOAD_SUCCESS";
export const LEADERSHIP_BOARD_LOAD_ERROR = "LEADERSHIP_BOARD_LOAD_ERROR";

// REPORTS MODULE
export const REPORTS_IS_LOADING = "REPORTS_IS_LOADING";
export const REPORTS_LOAD_SUCCESS = "REPORTS_LOAD_SUCCESS";
export const REPORTS_LOAD_ERROR = "REPORTS_LOAD_ERROR";

// QUIZ LIST IN COURSE DETAILS
export const QUIZ_LIST_IS_LOADING = "QUIZ_LIST_IS_LOADING";
export const QUIZ_LIST_LOAD_SUCCESS = "QUIZ_LIST_LOAD_SUCCESS";
export const QUIZ_LIST_LOAD_ERROR = "QUIZ_LIST_LOAD_ERROR";
export const RESET_QUIZ_LIST = "RESET_QUIZ_LIST";

//CURRENT TOPIC AND QUIZ BEING CONSUMED
export const SET_TOPIC_AND_QUIZ = "SET_TOPIC_AND_QUIZ";
export const RESET_TOPIC_AND_QUIZ = "RESET_TOPIC_AND_QUIZ";

// MY ACTIVITY MODULE
export const MY_ACTIVITY_IS_LOADING = "MY_ACTIVITY_IS_LOADING";
export const MY_ACTIVITY_LOAD_SUCCESS = "MY_ACTIVITY_LOAD_SUCCESS";
export const MY_ACTIVITY_LOAD_ERROR = "MY_ACTIVITY_LOAD_ERROR";
export const MY_ACTIVITY_RESET = "MY_ACTIVITY_RESET";

//LIVE COURSES MODULE
export const LIVE_COURSES_IS_LOADING = "LIVE_COURSES_IS_LOADING";
export const LIVE_COURSES_LOAD_SUCCESS = "LIVE_COURSES_LOAD_SUCCESS";
export const LIVE_COURSES_LOAD_ERROR = "LIVE_COURSES_LOAD_ERROR";

//START TOPIC
export const TOPIC_IS_STARTING = "TOPIC_IS_STARTING";
export const TOPIC_STARTED_SUCCESSFULLY = "TOPIC_STARTED_SUCCESSFULLY";
export const TOPIC_START_ERROR = "TOPIC_START_ERROR";
export const TOPIC_START_RESET = "TOPIC_START_RESET";

//COMMENTS
export const COMMENTS_IS_LOADING = "COMMENTS_IS_LOADING";
export const COMMENTS_LOAD_SUCCESS = "COMMENTS_LOAD_SUCCESS";
export const COMMENTS_LOAD_ERROR = "COMMENTS_LOAD_ERROR";
export const COMMENTS_RESET = "COMMENTS_RESET";

//SEARCH FUNCTION AUTOCOMPLETE
export const SEARCH_AUTOCOMPLETE_LIST_LOADING = 'SEARCH_AUTOCOMPLETE_LIST_LOADING';
export const SEARCH_QUERY_LOADING = "SEARCH_QUERY_LOADING";
export const SEARCH_COMPONENT_RESET = "SEARCH_COMPONENT_RESET";
export const SEARCH_FINAL_QUERY = "SEARCH_FINAL_QUERY";
export const SET_AUTOCOMPLETE_VISIBILITY = "SET_AUTOCOMPLETE_VISIBILITY";

//ADVANCED SEARCH
export const SET_ADVANCED_SEARCH = 'SET_ADVANCED_SEARCH';
export const RESET_ADVANCED_SEARCH = 'RESET_ADVANCED_SEARCH';

//MANAGE FAVOURITES IN LOCAL STORE
export const CHANGE_FAVOURITE_VALUE = 'CHANGE_FAVOURITE_VALUE';
export const START_SETTING_FAVOURITE = "START_SETTING_FAVOURITE";
export const END_SETTING_FAVOURITE = "END_SETTING_FAVOURITE";